import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=4c77ddd2&scoped=true&"
import script from "./CaseDetail.vue?vue&type=script&lang=js&"
export * from "./CaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=4c77ddd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c77ddd2",
  null
  
)

export default component.exports